import React, { ReactNode } from "react";
import { Box, createStyles, Grid, makeStyles } from "@material-ui/core";
import { Form, Formik, FormikProps } from "formik";
import * as Yup from "yup";
import CustomDialog from "./CustomDialog";
import CustomTextField from "../Input/CustomTextField";
import CustomButton from "../Button/CustomButton";
import StyledTooltip from "../Wrapper/StyledTooltip";

const useStyles = makeStyles(() =>
  createStyles({
    header: {
      textTransform: "uppercase",
    },
  }),
);

export interface SimpleTextDialogProps {
  onClose: () => void;
  onSave: (value: string) => void;
  open: boolean;
  title: string;
  disabledOnEmpty?: boolean;
  disabledHint?: string;
  label?: string;
  value?: string;
}

const SimpleTextDialog: React.FC<SimpleTextDialogProps> = (props) => {
  const classes = useStyles();
  const { open, onClose, onSave, title, label, value, disabledOnEmpty, disabledHint } = props;

  const renderForm = (formikProps: FormikProps<{ text: string }>): ReactNode => {
    const { errors, handleChange, touched, values } = formikProps;
    return (
      <Form {...formikProps}>
        <Box pb={4}>
          <Grid container justify="flex-start" direction="row">
            <CustomTextField
              autoFocus
              fullWidth
              error={!!errors.text && !!touched.text}
              helperText={touched.text ? errors.text : ""}
              id="text"
              label={label || title}
              value={values.text}
              onChange={handleChange}
            />
          </Grid>
        </Box>
        <Grid container item direction="row" justify="flex-end">
          {disabledOnEmpty && !values.text ? (
            <StyledTooltip title={disabledHint || ""}>
              <Box>
                <CustomButton primary text="Apply" type="submit" disabled />
              </Box>
            </StyledTooltip>
          ) : (
            <CustomButton primary text="Apply" type="submit" />
          )}
        </Grid>
      </Form>
    );
  };

  return (
    <CustomDialog fullWidth maxWidth="md" onClose={(): void => onClose()} open={open}>
      <h2 className={classes.header}>{title}</h2>
      <Formik
        initialValues={{
          text: value || "",
        }}
        validationSchema={Yup.object({
          text: Yup.string().required("Please fill out this field"),
        })}
        onSubmit={(formikValues): void => {
          onSave(formikValues.text);
        }}
      >
        {renderForm}
      </Formik>
    </CustomDialog>
  );
};

export default SimpleTextDialog;
